/**
 * The public list of demo teams (#2824): `GET /api/demo/scenarios`.
 * Shared by the `/demo` list and the `/demo/:scenario` blurb page.
 */
import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "../../api/client";

export interface DemoConsideration {
  text: string;
  /** Setup tab path, such as `stations` or `rules`. */
  setup_tab: string;
  /** Placeholder id the Setup tour points at. */
  anchor: string;
}

/** One change a visitor can pick on a demo team (#2824). */
export interface DemoChange {
  id: string;
  label: string;
}

export interface DemoScenarioCard {
  name: string;
  label: string;
  team_name: string;
  problem: string;
  considerations: DemoConsideration[];
  people_count: number;
  /** Industry id, when the API sends one (#2824). */
  industry?: string;
  /** The stored changes, in the order of the stored file. */
  changes?: DemoChange[];
}

export function useDemoScenarios() {
  return useQuery({
    queryKey: ["demo", "scenarios"],
    queryFn: () => apiFetch<DemoScenarioCard[]>("/api/demo/scenarios"),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

/** The team name without the trailing "(demo)" marker the files carry. */
export function displayTeamName(teamName: string): string {
  return teamName.replace(/\s*\(demo\)\s*$/i, "");
}
